import { render, staticRenderFns } from "./lists-table-loader.vue?vue&type=template&id=71f2e81f"
import script from "./lists-table-loader.vue?vue&type=script&lang=js"
export * from "./lists-table-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports